var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "OrderDetcontent" },
    [
      _vm.orderDetail.orderId
        ? _c(
            "van-row",
            { staticClass: "billDetail" },
            [
              _c(
                "van-col",
                { staticClass: "cont", attrs: { span: "24" } },
                [
                  _c(
                    "van-col",
                    { staticClass: "label", attrs: { span: "8" } },
                    [_vm._v("申请人：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "van-col",
                    { staticClass: "orderId", attrs: { span: "16" } },
                    [_vm._v(_vm._s(_vm.orderDetail.createUser))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "cont", attrs: { span: "24" } },
                [
                  _c(
                    "van-col",
                    { staticClass: "label", attrs: { span: "8" } },
                    [_vm._v("申请时间：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "van-col",
                    { staticClass: "orderId", attrs: { span: "16" } },
                    [_vm._v(_vm._s(_vm.orderDetail.createDate))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "cont", attrs: { span: "24" } },
                [
                  _c(
                    "van-col",
                    { staticClass: "label", attrs: { span: "8" } },
                    [_vm._v("热力卡号：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "van-col",
                    { staticClass: "orderId", attrs: { span: "16" } },
                    [_vm._v(_vm._s(_vm.orderDetail.roomInfo.userCardNumber))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "cont", attrs: { span: "24" } },
                [
                  _c(
                    "van-col",
                    { staticClass: "label", attrs: { span: "8" } },
                    [_vm._v("地址：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "van-col",
                    { staticClass: "orderId", attrs: { span: "16" } },
                    [_vm._v(_vm._s(_vm.orderDetail.roomInfo.roomAddress))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "cont", attrs: { span: "24" } },
                [
                  _c(
                    "van-col",
                    { staticClass: "label", attrs: { span: "8" } },
                    [_vm._v("原供热状态：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "van-col",
                    { staticClass: "orderId", attrs: { span: "16" } },
                    [_vm._v(_vm._s(_vm.orderDetail.originalStatusText))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "cont", attrs: { span: "24" } },
                [
                  _c(
                    "van-col",
                    { staticClass: "label", attrs: { span: "8" } },
                    [_vm._v("更改后供热状态：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "van-col",
                    { staticClass: "orderId", attrs: { span: "16" } },
                    [_vm._v(_vm._s(_vm.orderDetail.changeStatusText))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "cont", attrs: { span: "24" } },
                [
                  _c(
                    "van-col",
                    { staticClass: "label", attrs: { span: "8" } },
                    [_vm._v("审核状态：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "van-col",
                    { staticClass: "orderId", attrs: { span: "16" } },
                    [_vm._v(_vm._s(_vm.orderDetail.statusText))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.orderDetail.status == 2
                ? _c(
                    "van-col",
                    { staticClass: "cont", attrs: { span: "24" } },
                    [
                      _c(
                        "van-col",
                        { staticClass: "label", attrs: { span: "8" } },
                        [_vm._v("审批结果：")]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "orderId", attrs: { span: "16" } },
                        [_vm._v(_vm._s(_vm.orderDetail.result))]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "label", attrs: { span: "8" } },
                        [_vm._v("审批人：")]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "orderId", attrs: { span: "16" } },
                        [_vm._v(_vm._s(_vm.orderDetail.name))]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "label", attrs: { span: "8" } },
                        [_vm._v("审批时间：")]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "orderId", attrs: { span: "16" } },
                        [_vm._v(_vm._s(_vm.orderDetail.updateDate))]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "cont", attrs: { span: "24" } },
                [
                  _c(
                    "van-col",
                    { staticClass: "label", attrs: { span: "8" } },
                    [_vm._v("备注：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "van-col",
                    { staticClass: "orderId", attrs: { span: "16" } },
                    [_vm._v(_vm._s(_vm.orderDetail.remark))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3419c5ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3419c5ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Stop/detail.vue
// module id = null
// module chunks = 